import { Amplify } from "aws-amplify";

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "",
        userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || "",
        loginWith: {
          phone: true,
        },
      },
    },
  });
};

export const currentConfig = Amplify.getConfig();
